"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const Tooltip_1 = tslib_1.__importDefault(require("./Tooltip"));
const OverlayTrigger_1 = tslib_1.__importDefault(require("../overlay/OverlayTrigger"));
const Placement_1 = require("../../values/Placement");
const Trigger_1 = require("../../values/Trigger");
const SimpleTooltip = (props) => {
    const { children, placement = Placement_1.PLACEMENT.AUTO, trigger, content, delay, popperConfig, targetRef } = props, remainingProps = tslib_1.__rest(props, ["children", "placement", "trigger", "content", "delay", "popperConfig", "targetRef"]);
    return ((0, jsx_runtime_1.jsx)(OverlayTrigger_1.default, Object.assign({ placement: placement, trigger: trigger, overlay: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({}, remainingProps, { ref: targetRef }, { children: content })), delay: delay, popperConfig: popperConfig }, { children: children })));
};
SimpleTooltip.TRIGGER_CLICK = Trigger_1.TRIGGER.CLICK;
SimpleTooltip.TRIGGER_HOVER = Trigger_1.TRIGGER.HOVER;
SimpleTooltip.TRIGGER_FOCUS = Trigger_1.TRIGGER.FOCUS;
exports.default = SimpleTooltip;
